import { Typography } from "@mui/material";
import SectionCard from "../../../components/SectionCard";

export default function AboutMe() {
  return (
    <SectionCard title="About">
      <Typography sx={{ lineHeight: 1.7 }}>
        I work as an ASIC engineer after earning a Master's degree in Computer
        Engineering, but my interests extend across the entire technology stack.
        Throughout my career, I have worked in full-stack software development,
        embedded systems, data visualization, and hardware design.
      </Typography>

      <Typography sx={{ lineHeight: 1.7, mt: 2 }}>
        My fascination with technology began when I received an old Dell
        OptiPlex tower as a teenager. Since then, I have spent countless hours
        building, repairing, and upgrading desktops and laptops, as well as
        customizing software to make my systems work exactly the way I want them
        to.
      </Typography>

      <Typography sx={{ lineHeight: 1.7, mt: 2 }}>
        I believe in owning, controlling, and repairing the technology I rely
        on. I self-host media, photos, backups, and home automation systems, and
        I enjoy experimenting with networking infrastructure and other homelab
        projects. I prefer solutions that reduce personal dependence on cloud
        services, protect privacy, and limit advertising, and I enjoy the
        challenge of designing and maintaining those systems myself.
      </Typography>
    </SectionCard>
  );
}
